import moment from 'moment';

const dateUtils = {
  getFormattedDate: function (date) {
    return date.split('T')[0].replace(/-/g, '/');
  },
  getDateInSpFormat: function (date) {
    return date;
  },
  getMonth: function (number) {
    return [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre'
    ][number]
  },
  isValidDate: function (date) {
    const regex = RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/);
    const isCompleteDate = regex.test(date);
    if (isCompleteDate) return new Date(date) > 0;
    return false;
  },
  getSectorHorarioFromTo: function (fromDate, toDate) {
    let fromString = moment(fromDate).format('HH:MM');
    let toString = moment(toDate).format('HH:MM');

    return `${fromString} - ${toString}`
  },
  getDjangODate: function(date) {
    return moment(date).format('YYYY-MM-DD')
  },
}

export default dateUtils;